import { FlexContainer } from '@busie/ui-kit'
import React from 'react'
import { ManeuverIcon } from '@busie/ui-kit'
import { DottedLine, ManeuverText } from './styled'
import { ManeuverPosition } from '@busie/api'

interface Props {
  position: ManeuverPosition
  text: string
}

const Manuever: React.FC<React.PropsWithChildren<Props>> = ({
  position,
  text,
}) => {
  return (
    <FlexContainer columnGap={2} align="center" sx={{ position: 'relative' }}>
      <ManeuverIcon position={position} />
      {['origin', 'middle'].includes(position) && <DottedLine />}
      <ManeuverText>{text}</ManeuverText>
    </FlexContainer>
  )
}

export default Manuever
